import { createContext, useContext, useEffect, useState } from 'react';
import { getVendorProfile } from 'services/vendor';
import { getToken, isTokenExpired, VENDOR_SESSION_EVENT } from 'services/tokenStorage';

const VendorContext = createContext(null);

export const VendorProvider = ({ children }) => {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadVendor = async () => {
    if (!getToken() || isTokenExpired()) {
      setVendor(null);
      setLoading(false);
      return;
    }

    try {
      const res = await getVendorProfile();
      if (res?.status) {
        setVendor(res.data);
      }
    } catch (err) {
      console.error('Failed to load vendor profile', err);
      setVendor(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadVendor();
  }, []);

  useEffect(() => {
    const handleSessionEvent = (event) => {
      if (event.detail?.reason === 'updated') {
        loadVendor();
        return;
      }

      setVendor(null);
      setLoading(false);
    };

    window.addEventListener(VENDOR_SESSION_EVENT, handleSessionEvent);
    return () => window.removeEventListener(VENDOR_SESSION_EVENT, handleSessionEvent);
  }, []);

  return (
    <VendorContext.Provider
      value={{
        vendor,
        reloadVendor: loadVendor,
        loading,
      }}
    >
      {children}
    </VendorContext.Provider>
  );
};

export const useVendor = () => useContext(VendorContext);
